import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationprojectCycleValueAdjustmentsConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationprojectCycleValueAdjustments";
    static FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_VALUE_ADJUSTMENTS = "DeleteMultipleprojectCycleValueAdjustments";
    static FUNCTION_UPLOAD_GENERAL_VALUATION_RUN_VALUE_ADJUSTMENTS = "UploadprojectCycleValueAdjustments";
}
